export default "<app-invoice-list></app-invoice-list>\r\n";